(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvErrorPanel', drvErrorPanel);

    drvErrorPanelCtrl.$inject = ['NavigationAidService'];

    /**
     * A simple error panel.
     * Stick some text in it and use ng-if so it only shows if there is an error.
     * E.g. "Email not found"
     */
    function drvErrorPanel() {
        var directive = {
            controller: drvErrorPanelCtrl,
            controllerAs: 'drvCtrl',
            templateUrl: 'app/Controls/error-panel.tmpl.html',
            transclude: true,
            scope: {},
            bindToController: {
                hideCloseButton: '<?'
            }
        };

        return directive;
    }

    function drvErrorPanelCtrl(NavigationAidService) {
        /* jshint validthis:true */
        var drvCtrl = this;

        drvCtrl.close = close;

        function close() {
            console.log('error panel close');
            NavigationAidService.goBack();
        }
    }
})();
